module.exports = __webpack_public_path__ + "static/media/ljnljn.2f9c1990.png";